/**
* @prop --uic-header-height: height of the header
* @prop --uic-header-bg-color: default background color
* @prop --uic-header-bg-color-secondary: secondary background color used for the home button
* @prop --uic-header-text-color: default text and icon color
* @prop --uic-header-text-color-active: text, icon and outline color for active elements
* @prop --uic-header-text-color-disabled: text, icon and outline color for disabled elements
* @prop --uic-header-z-index: z-index of the header
*/
uic-header {
    --uic-icon-width: var(--uic-header-icon-size);
    --uic-icon-height: var(--uic-header-icon-size);
    position: relative;
    width: 100%;
    height: var(--uic-header-height);
    overflow: visible;
    display: block;
    z-index: var(--uic-header-z-index);

    .uic-header {
        &__home {
            z-index: 1;
        }

        &__nav,
        &__menu-left,
        &__menu-right {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            height: 100%;
        }

        &__nav {
            width: 100%;
            height: 100%;
            justify-content: space-between;
            background-color: var(--uic-header-bg-color);
            color: var(--uic-header-text-color);
        }

        &__menu-wrapper {
            flex: 1 1 auto;
            overflow: hidden;
            height: 100%;
        }

        &__menu-left {
            flex: 1 0 auto;
            overflow: hidden;
            scroll-behavior: smooth;
        }

        &__spacer {
            flex: 1 1 auto;
        }

        &__flyouts {
            position: absolute;
            left: 0;
            top: 100%;
            width: 100%;

            > *:not(uic-flyout) {
                display: none;
            }
        }
    }

    uic-flyout {
        top: 0;
    }

    [slot="home"] uic-header-menu-item {
        min-width: 85px;
        margin-right: 1px;

        @media #{$breakpoint_smartphone} {
            min-width: 65px;
        }
    }
}

.uic-header__submenu {
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;

    &--hidden {
        display: none;
    }
}

.uic-header__menu-wrapper {
    position: relative;

    &--cropped {
        &::before,
        &::after {
            content: "";
            display: block;
            width: 40px;
            height: 100%;
            pointer-events: none;
            position: absolute;
            top: 0;
            z-index: 1;
            opacity: 0;
            transition: opacity 0.5s ease-out;
        }

        &::before {
            left: 0;
            background: linear-gradient(
                90deg,
                var(--uic-header-bg-color, rgba(0, 0, 0, 0)) 0%,
                var(--uic-header-bg-color-transparent, rgba(0, 0, 0, 0)) 100%
            );
        }

        &::after {
            right: 0;
            background: linear-gradient(
                90deg,
                var(--uic-header-bg-color-transparent, rgba(0, 0, 0, 0)) 0%,
                var(--uic-header-bg-color) 100%
            );
        }
    }

    &--cropped-left::before {
        opacity: 1;
    }

    &--cropped-right::after {
        opacity: 1;
    }
}
